<template>
  <div>
    <v-container fluid>
      <v-card class="reportdata-card-main" >
        
        <v-card-text style="padding: 0;">
          <div class="pb-3 mb-5" style="border-bottom: 1px solid #C9C9C9;">
            <h3 class="text-h5 mt-5" style="font-weight: 600; font-size: 28px !important;">
              {{ $t('userReportManagement') }}
            </h3>
          </div>
          <div class="border px-5 pt-3 mb-4" style="border-radius: 16px;">
          <!-- Date Range Section -->
            <div class="reportdata-filter-section">
              <h4 class="reportdata-section-title mb-3 d-flex align-center border-0">
                <img src="@/assets/Icons/new_arrow_range.png" alt="arrow icon" class="mr-2"/>
                <span style="font-size: 20px; font-weight: 600;">{{ $t('dateRange') }}</span>
              </h4>
              <v-row class="px-0">
                <v-col cols="7" class="mb-2">
                  <v-row class="">
                    <v-col cols="5" class="pe-0">
                      <span>{{ $t('startDate') }}
                        <v-tooltip location="top start">
                          {{ $t('selectStartDateSearch') }}
                          <template #activator="{ props }">
                            <v-icon
                              v-bind="props"
                              size="20"
                              class="info-icon"
                              color="grey"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                        </v-tooltip>
                      </span>
                      <v-menu
                        v-model="startDateFlag"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        location="bottom"
                        min-width="auto">
                        <template #activator="{ props }">
                          <v-text-field
                            id="startdate-field-reportusertop10"
                            :model-value="formatDateDisplay(startDate)"
                            :placeholder="$t('Select date')"
                            readonly
                            variant="outlined"
                            v-bind="props"
                            density="compact"
                            color="primary"
                            class="reportdata-field-date mt-1"
                            clearable
                            @click:clear="startDate = null">
                            <template v-slot:prepend-inner>
                              <img src="@/assets/Icons/new_calendar.png" alt="calendar" style="width: 20px; height: 20px;" />
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          id="startdate-datapicker-reportusertop10"
                          v-model="startDate"
                          :key="`start-${startPickerYear}-${startPickerMonth}`"
                          :year="startPickerYear"
                          :month="startPickerMonth"
                          @update:year="startPickerYear = $event"
                          @update:month="startPickerMonth = $event"
                          :max="new Date().toISOString().substr(0, 10)"
                          @update:model-value="
                            (val) => {
                              startDate = formatDate(val);
                              startDateFlag = false;
                            }
                          "
                          show-adjacent-months
                          class="date-picker">
                          <template #header>
                            <div class="picker-header-custom d-flex align-center justify-space-between px-4 py-3">
                              <div class="text-h6 font-weight-medium">{{ getFormattedHeaderDate(startPickerYear, startPickerMonth, startDate) }}</div>
                              <v-select
                                v-model="startPickerYear"
                                :items="years"
                                density="compact"
                                variant="plain"
                                hide-details
                                class="month-year-select"
                                style="width: 100px;"
                              ></v-select>
                            </div>
                          </template>
                        </v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="1" class="d-flex align-center justify-center px-0">
                      <img src="@/assets/Icons/new_dash.png" alt="">
                    </v-col>

                    <v-col cols="5" class="ps-0">
                      <span>{{ $t('endDate') }}
                        <v-tooltip location="top start">
                          {{ $t('selectEndDateSearch') }}
                          <template #activator="{ props }">
                            <v-icon
                              v-bind="props"
                              size="20"
                              class="info-icon"
                              color="grey"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                        </v-tooltip>
                      </span>
                      <v-menu
                        v-model="endDateFlag"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        location="bottom"
                        min-width="auto">
                        <template #activator="{ props }">
                          <v-text-field
                            id="enddate-field-reportusertop10"
                            :model-value="formatDateDisplay(endDate)"
                            :placeholder="$t('Select date')"
                            readonly
                            variant="outlined"
                            v-bind="props"
                            density="compact"
                            color="primary"
                            class="reportdata-field-date mt-1"
                            clearable
                            @click:clear="endDate = null"
                          >
                            <template v-slot:prepend-inner>
                              <img src="@/assets/Icons/new_calendar.png" alt="calendar" style="width: 20px; height: 20px;" />
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          id="enddate-datapicker-reportusertop10"
                          v-model="endDate"
                          :key="`end-${endPickerYear}-${endPickerMonth}`"
                          :year="endPickerYear"
                          :month="endPickerMonth"
                          @update:year="endPickerYear = $event"
                          @update:month="endPickerMonth = $event"
                          :min="startDate != null ? startDate : null"
                          @update:model-value="
                            (val) => {
                              endDate = formatDate(val);
                              endDateFlag = false;
                            }
                          "
                          color="#C32E0E"
                          class="date-picker">
                          <template #header>
                            <div class="picker-header-custom d-flex align-center justify-space-between px-4 py-3">
                              <div class="text-h6 font-weight-medium">{{ getFormattedHeaderDate(endPickerYear, endPickerMonth, endDate) }}</div>
                              <v-select
                                v-model="endPickerYear"
                                :items="years"
                                density="compact"
                                variant="plain"
                                hide-details
                                class="month-year-select"
                                style="max-width: 90px;"
                              ></v-select>
                            </div>
                          </template>
                        </v-date-picker>
                      </v-menu>
                    </v-col>

                    <!-- Action Button Section -->
                    <v-col
                      cols="12"
                      md="1"
                      class="px-0"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      ">
                      <v-btn
                        id="button-search-reportusertop10"
                        variant="elevated"
                        @click="Search()"
                        size="small"
                        class="reportdata-btn-search"
                        style="
                          background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%); 
                          max-width: 45px !important; 
                          min-width: 47px !important;
                          height: 45px !important;
                          border-radius: 50% !important;
                          box-shadow: none !important;
                        ">
                        <img
                          src="@/assets/Icons/new_search_bold.svg"
                          alt="search icon"
                        />
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" lg="1" class="d-none d-lg-flex justify-center">
                  <v-divider
                    vertical
                    thickness="2"
                    length="45"
                    style="background: #C9C9C9; margin-top: 20px; opacity: 1;"
                  ></v-divider>
                </v-col>
                <v-col cols="4">
                  <span>{{ $t('quickDateRange') }}</span>
                  <div class="d-flex justify-center align-center" style="gap: 32px">
                    <v-select
                      id="quickdaterange-select-reportusertop10"
                      :placeholder="$t('selectQuickDateRange')"
                      :items="quickDateRangeOptions"
                      item-title="title"
                      item-value="value"
                      v-model="quickDateRange"
                      variant="outlined"
                      density="comfortable"
                      hide-details="auto"
                      class="modern-autocomplete mt-1"
                      @update:model-value="applyQuickDateRange"
                    >
                      <template v-slot:prepend-inner>
                        <img src="@/assets/Icons/new_calendar_white.png" alt="calendar" style="width: 20px; height: 20px;" />
                      </template>
                      <template v-slot:item="{ props, item }">
                        <v-list-item
                          v-bind="props"
                          :title="item.raw.title"
                          class="quickdate-list-item"
                        ></v-list-item>
                      </template>
                    </v-select>
                    <v-btn
                      size="small"
                      @click="resetDateFilter"
                      style="
                        align-self: baseline;
                        background: white !important; 
                        max-width: 46px !important; 
                        min-width: 44px !important;
                        height: 45px !important;
                        border-radius: 50% !important;
                        box-shadow: none !important;
                        border: 1px solid #C9C9C9 !important;
                      ">
                      <img src="@/assets/Icons/new_rotate.png" width="24" height="24" alt="reset icon" />
                      <v-tooltip location="top" activator="parent">
                        {{ $t('resetToDefault') }}
                      </v-tooltip>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>

          <!-- Top 3 Ranking Cards -->
          <div class="border px-5 py-3 mb-4" style="border-radius: 16px;">
            <v-row class="mb-1">
              <v-col cols="12">
                <div class="reportdata-filter-section">
                  <h4 class="reportdata-section-title pb-0 d-flex align-center border-0" style="font-size: 20px;">
                    <img src="@/assets/Icons/new_top_user_icon.png" alt="top user icon" class="mr-2"/>
                    {{ $t('top3Users') }}
                  </h4>
                  <v-row class="mt-3">
                    <v-col
                      v-for="item in dataTable.slice(0, 3)"
                      :key="item.no"
                      cols="12"
                      sm="4"
                      md="4">
                      <v-card
                        class="reportdata-user-rank-card pa-2"
                        :class="`rank-${item.no}`"
                        style="border-radius: 32px !important; box-shadow: none !important;"
                        elevation="4"
                      >
                        <v-card-text style="background: white; border-radius: 28px !important;">
                          <v-row>
                            <v-col cols="3" class="d-flex justify-center align-center">
                              <div :class="topThreeFirstBorder(item.no)" style="max-height: 70px;">
                                <div :class="topThreeSecondBorder(item.no)">
                                  <v-chip
                                    size="small"
                                    class="top-rank-chip"
                                    variant="outlined"
                                    style="min-height: 40px; min-width: 42px; font-size: 20px;">
                                    {{ item.no }}
                                  </v-chip>
                                </div>
                              </div>
                            </v-col>
                            <v-col cols="9" class="">
                              <div class="reportdata-user-rank-content">
                                <label for="" style="font-size: 18px; font-weight: 600;">{{ $t('userIdCol') }}</label>
                                <div class="d-flex align-center" style="gap: 8px;">
                                  <div>
                                    <span class="user-text">
                                      {{ item.title[0] }}
                                    </span>
                                  </div>
                                  <v-menu
                                    v-if="item.title.length > 1"
                                    v-model="expandedTopUsers[item.no]"
                                    :close-on-content-click="false"
                                    location="bottom"
                                    offset="8"
                                  >
                                    <template #activator="{ props }">
                                      <v-btn
                                        icon
                                        size="x-small"
                                        variant="text"
                                        v-bind="props"
                                        style="min-width: 24px; min-height: 24px;">
                                        <v-icon size="20" color="#001763">
                                          {{ expandedTopUsers[item.no] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                                        </v-icon>
                                        <v-tooltip location="top" activator="parent">
                                          {{ $t('seeAll') }}
                                        </v-tooltip>
                                      </v-btn>
                                    </template>
                                    <v-card min-width="300" max-width="400" class="user-id-dropdown">
                                      <v-list density="compact">
                                        <v-list-item
                                          v-for="(subItem, index) in item.title.slice(1)"
                                          :key="index"
                                          :title="subItem"
                                        >
                                        </v-list-item>
                                      </v-list>
                                    </v-card>
                                  </v-menu>
                                </div>
                                <div 
                                  class="count-section text-center" 
                                  style="
                                    position: absolute; 
                                    top: 20px; 
                                    right: 20px;
                                  "
                                >
                                  <v-chip
                                    size="large"
                                    style="box-shadow: none;"
                                    :style="item.no == 1 ? 'background: #FF4C4D !important;' : item.no == 2 ? 'background: #06966D !important;' : 'background: #2079F0 !important;'"
                                    variant="elevated"
                                    class="px-4">
                                    <span class="mr-2" style="font-weight: 700; font-size: 18px;">{{ item.count }}</span>
                                    <span style="font-size: 13px;">{{ $t('Questions') }}</span>
                                  </v-chip>
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- Complete Ranking Table -->
          <v-card class="reportdata-card-table border px-4 py-5" style="border-radius: 16px !important;">
            <h1 class="mb-4" style="font-weight: 600;">{{ $t('userReportData') }}</h1>
            <div class="reportdata-table-container">
              <v-data-table-server
                :items="dataTable"
                :headers="headers"
                hide-default-footer
                class="reportdata-table-modern"
                density="comfortable"
                hover
              >
                <template #item="{ item }">
                  <tr class="reportdata-table-row">
                    <td class="text-center">
                      <div :class="chipBorderClass(item.no)">
                        <v-chip
                          size="small"
                          class="rank-chip"
                          variant="outlined"
                          style="min-height: 30px; min-width: 32px;">
                          {{ item.no }}
                        </v-chip>
                      </div>
                    </td>
                    <td>
                      <div class="reportdata-text-container d-flex align-center justify-space-between" style="width: 100%;">
                        <div>
                          <span
                            v-for="(subItem, index) in (item.title.length > 2 && !expandedTableRows[item.no] ? item.title.slice(0, 2) : item.title)"
                            :key="subItem"
                            class="reportdata-text-standard">
                            {{ subArray(subItem, index, item.title.length > 2 && !expandedTableRows[item.no] ? 2 : item.title.length) }}
                          </span>
                        </div>
                        <v-btn
                          v-if="item.title.length > 2"
                          icon
                          size="x-small"
                          variant="text"
                          @click="toggleTableRow(item.no)"
                          style="min-width: 20px; min-height: 20px; flex-shrink: 0;">
                          <v-icon size="22" color="#001763">
                            {{ expandedTableRows[item.no] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                          </v-icon>
                          <v-tooltip location="top" activator="parent">
                            {{ $t('seeAll') }}
                          </v-tooltip>
                        </v-btn>
                        <div v-else style="min-width: 20px; height: 20px; flex-shrink: 0;"></div>
                      </div>
                    </td>
                    <td class="text-center">
                      {{ substringLong(item.count) }}
                    </td>
                  </tr>
                </template>
              </v-data-table-server>
            </div>
          </v-card>
        </v-card-text>
      </v-card>
    </v-container>
    <v-overlay :value="loading">
      <v-dialog v-model="loading" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            {{ $t('loadingPleaseWait') }}
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
const LogTrace = checkPermissionTwo;
export default {
  name: "ReportUserTop10",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  mixins: [checkPermissionTwo, LogTrace],
  data() {
    const currentDate = new Date();
    return {
      today: null,
      loading: true,
      options: {},

      startDateFlag: false,
      endDateFlag: false,
      startDate: null,
      endDate: null,

      dataTable: [],
      expandedTopUsers: {},
      expandedTableRows: {},
      
      quickDateRange: 'Today',

      startPickerYear: currentDate.getFullYear(),
      startPickerMonth: currentDate.getMonth(),
      endPickerYear: currentDate.getFullYear(),
      endPickerMonth: currentDate.getMonth(),
      
      years: Array.from({ length: 10 }, (_, i) => currentDate.getFullYear() - i),
      months: [
        { text: 'January', value: 0 },
        { text: 'February', value: 1 },
        { text: 'March', value: 2 },
        { text: 'April', value: 3 },
        { text: 'May', value: 4 },
        { text: 'June', value: 5 },
        { text: 'July', value: 6 },
        { text: 'August', value: 7 },
        { text: 'September', value: 8 },
        { text: 'October', value: 9 },
        { text: 'November', value: 10 },
        { text: 'December', value: 11 },
      ],
    };
  },
  computed: {
    headers() {
      return [
        {
          title: this.$t("Rank"),
          align: "center",
          width: "30px",
          sortable: false,
        },
        {
          title: this.$t("userIdCol"),
          align: "left",
          sortable: false,
          width: "500px",
        },
        {
          title: this.$t("totalQuestions"),
          align: "center",
          sortable: false,
          width: "100px",
        },
      ];
    },
    quickDateRangeOptions() {
      return [
        { title: this.$t("today"), value: "Today" },
        { title: this.$t("yesterday"), value: "Yesterday" },
        { title: this.$t("last30Days"), value: "Last30Days" },
        { title: this.$t("thisMonth"), value: "ThisMonth" },
      ];
    },
  },
  watch: {
    startDateFlag(newVal) {
      if (newVal) {
        if (this.startDate) {
          const date = new Date(this.startDate);
          this.startPickerYear = date.getFullYear();
          this.startPickerMonth = date.getMonth();
        } else {
          const today = new Date();
          this.startPickerYear = today.getFullYear();
          this.startPickerMonth = today.getMonth();
        }
      }
    },
    endDateFlag(newVal) {
      if (newVal) {
        if (this.endDate) {
          const date = new Date(this.endDate);
          this.endPickerYear = date.getFullYear();
          this.endPickerMonth = date.getMonth();
        } else {
          const today = new Date();
          this.endPickerYear = today.getFullYear();
          this.endPickerMonth = today.getMonth();
        }
      }
    },
    // options: {
    //   handler() {
    //     this.GetReport();
    //   },
    //   deep: true,
    // },
  },
  methods: {
    applyQuickDateRange(range) {
      const today = new Date();
      let startDate, endDate;

      switch (range) {
        case 'Yesterday':
          startDate = new Date(today);
          startDate.setDate(startDate.getDate() - 1);
          endDate = new Date(startDate);
          break;
        
        case 'Last30Days':
          startDate = new Date(today);
          startDate.setDate(startDate.getDate() - 30);
          endDate = new Date(today);
          break;
        
        case 'ThisMonth':
          startDate = new Date(today.getFullYear(), today.getMonth(), 1);
          endDate = new Date(today);
          break;

        case 'Today':
        default:
          startDate = new Date(today);
          endDate = new Date(today);
          break;
      }

      this.startDate = this.convertDateToString2(startDate);
      this.endDate = this.convertDateToString2(endDate);
      this.GetReport();
    },
    
    resetDateFilter() {
      this.quickDateRange = 'Today';
      this.applyQuickDateRange('Today');
    },
    
    toggleTableRow(itemNo) {
      this.expandedTableRows[itemNo] = !this.expandedTableRows[itemNo];
    },
    
    chipBorderClass(rank) {
      if (rank === 1) {
        return "rank-chip-border rank-chip-first";
      }
      if (rank === 2) {
        return "rank-chip-border rank-chip-second";
      }
      if (rank === 3) {
        return "rank-chip-border rank-chip-third";
      }
      return "rank-chip-border rank-chip-default";
    },
    topThreeFirstBorder(rank) {
      if (rank === 1) {
        return "top-first-chip-border top-first-chip-first";
      }
      if (rank === 2) {
        return "top-first-chip-border top-first-chip-second";
      }
      if (rank === 3) {
        return "top-first-chip-border top-first-chip-third";
      }
      return "top-first-chip-border top-first-chip-default";
    },
    topThreeSecondBorder(rank) {
      if (rank === 1) {
        return "top-chip-border top-chip-first";
      }
      if (rank === 2) {
        return "top-chip-border top-chip-second";
      }
      if (rank === 3) {
        return "top-chip-border top-chip-third";
      }
      return "top-chip-border top-chip-default";
    },


    Search() {
      this.loading = true;
      this.GetReport();
    },

    GetReport() {
      this.loading = true;

      if (this.startDate != null && this.endDate != null) {
        let temp = {
          StartDate: this.startDate,
          EndDate: this.endDate,
        };

        this.$call.ReportUser(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.dataTable = dataResponse.data;
            } else {
              this.dataTable = [];
            }
            this.loading = false;
          },
          (errorResource) => {
            this.loading = false;
            console.error(errorResource);
          }
        );
      } else {
        this.showWarningAlert(this.$t('actionNeeded'), this.$t('dateRangeRequired'));
        this.loading = false;
      }
    },

    showWarningAlert(title, messageHtml) {
      const rawOkLabel = this.$t ? this.$t("ok") : "OK";
      const confirmLabel = rawOkLabel && rawOkLabel.toString().trim().length > 0
        ? rawOkLabel
        : "OK";

      return this.$swal.fire({
        title,
        html: messageHtml,
        icon: "warning",
        showCloseButton: true,
        focusConfirm: true,
        buttonsStyling: false,
        allowOutsideClick: false,
        confirmButtonText: confirmLabel,
        customClass: {
          popup: "swal-warning-popup",
          title: "swal-warning-title",
          htmlContainer: "swal-warning-body",
          actions: "swal-warning-actions",
          confirmButton: "swal-warning-confirm",
          closeButton: "swal-warning-close",
        },
      });
    },



    substringLong(value) {
      if (value == null) {
        return "-";
      }
      if (value.length > 81) {
        return value.substring(0, 80) + ".....";
      }
      return value;
    },

    subArray(value, index, sum) {
      if (index == sum - 1) {
        return value;
      } else {
        return value + ", ";
      }
    },
  },
  mounted() {
    this.GetDate();
    const date = new Date();
    this.endDate = this.convertDateToString2(date);
    this.startDate = this.convertDateToString2(date);
    this.quickDateRange = 'Today';
    this.GetReport();
  },
};
</script>
<style scoped>
.rank-1-header {
  background: linear-gradient(135deg, #ffd700, #ffa500) !important;
}

.rank-2-header {
  background: linear-gradient(135deg, #c0c0c0, #a8a8a8) !important;
}

.rank-3-header {
  background: linear-gradient(135deg, #cd7f32, #d2691e) !important;
}

.rank-1 {
  background: linear-gradient(100deg, #FF4C4D 0%, #FAA2E0 100%); 
}
.rank-2 {
  background: linear-gradient(100deg, #06966D 0%, #16C4B6 100%); 
}
.rank-3 {
  background: linear-gradient(100deg, #2079F0 0%, #6FC9E3 100%); 
}

.rank-chip-border {
  display: inline-flex;
  padding: 4px;
  border-radius: 20px;
}

.top-chip-border {
  display: inline-flex;
  padding: 7px;
  border-radius: 30px;
}

.top-first-chip-border {
  display: inline-flex;
  padding: 7px;
  border-radius: 40px;
}

.rank-chip-first {
  background: linear-gradient(90deg, #ff4c4d 0%, #faa2e0 100%);
}
.rank-chip-second {
  background: linear-gradient(90deg, #16c4b6 0%, #06966d 100%);
}
.rank-chip-third {
  background: linear-gradient(90deg, #2079f0 0%, #6fc9e3 100%);
}
.rank-chip-default {
  background: #c9c9c9;
}

.top-chip-first {
  background: linear-gradient(90deg, #ff4c4d 0%, #faa2e0 100%);
}
.top-chip-second {
  background: linear-gradient(90deg, #06966d 0%, #16c4b6 100%);
}
.top-chip-third {
  background: linear-gradient(90deg, #2079f0 0%, #6fc9e3 100%);
}
.top-chip-default {
  background: #c9c9c9;
}

.top-first-chip-first {
  background: linear-gradient(45deg, #faa2e045 0%, #ff4c4d45 100%);
}
.top-first-chip-second {
  background: linear-gradient(45deg, #06966d45 0%, #16c4b645 100%);
}
.top-first-chip-third {
  background: linear-gradient(45deg, #6fc9e345 0%, #2079f045 100%);
}
.top-first-chip-default {
  background: #c9c9c9;
}

.rank-chip {
  background-color: #ffffff !important;
  border: none !important;
  min-width: 32px;
  justify-content: center;
}
.top-rank-chip {
  background-color: #ffffff !important;
  border: none !important;
  min-width: 32px;
  justify-content: center;
}
.top-rank-chip :deep(.v-chip__content) {
  font-weight: 700 !important;
  font-size: 26px !important;
}

.reportdata-btn-search:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
  box-shadow: none !important;
}

.reportdata-card-main{
  border: none !important;
  box-shadow: none !important;
}
.reportdata-field-date :deep(.v-field) {
  border-radius: 16px !important;
}
.modern-autocomplete :deep(.v-field) {
  border-radius: 40px !important;
  max-height: 40px !important;
}
.modern-autocomplete :deep(.v-field__input) {
  max-height: 40px !important;
  min-height: 40px !important;
  padding: 6px 6px 6px 12px ;
}
.v-table :deep(.v-data-table__th) {
  border-bottom: none !important;
}
.v-table :deep(.v-data-table__thead tr th:first-child) {
  border-radius: 16px 0 0 0 !important;
  background: #FFF2F2;     /* header radius */
}
.v-table :deep(.v-data-table__thead tr th:last-child) {
  border-radius: 0 16px 0 0 !important;
  background: #FFF2F2;     /* header radius */
}
.v-table :deep(.v-data-table__thead tr th:not(:first-child):not(:last-child)) {
  border-radius: 0 0 0 0 !important;
  background: #FFF2F2;     /* header radius */
}
.v-table :deep(.v-data-table-header__content span) {
  font-weight: 600 !important;
}
.v-table :deep(.v-data-table__tbody tr td){
  border-bottom: 1px solid #E1E1E1 !important;
}
.v-table :deep(.v-data-table__tbody tr):hover {
  background: #FFFCFC !important;
}
.v-table :deep(.v-data-table-rows-no-data td) {
  text-align: center;
}

.user-text{
  display: inline-block;
  max-width: clamp(100px, 20vw, 200px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: wrap;
  vertical-align: middle;
}

.user-id-dropdown {
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border-radius: 8px !important;
}

.user-id-dropdown :deep(.v-list) {
  padding: 8px 12px;
}
.user-id-dropdown :deep(.v-list-item) {
  min-height: 40px;
  padding: 8px 0;
}
.user-id-dropdown :deep(.v-list-item:not(:last-child)) {
  border-bottom: 1px solid #CCCCCC;
}
.user-id-dropdown :deep(.v-list-item:hover) {
  color: #001763;
  background: #CDD5F3;
}

.modern-autocomplete :deep(.v-input) {
  border-radius: 40px !important;
}
.modern-autocomplete :deep(.v-list) {
  padding: 8px 16px;
}
.modern-autocomplete :deep(.v-list-item) {
  min-height: 40px;
  padding: 8px 0;
  border-bottom: 1px solid #CCCCCC;
}
.modern-autocomplete :deep(.v-list-item:hover) {
  color: #001763 !important;
  background: #CDD5F3 !important;
}
.modern-autocomplete :deep(.v-list-item--active) {
  color: #001763 !important;
  background: #CDD5F3 !important;
}
.modern-autocomplete :deep(.v-list-item .v-list-item-title) {
  transition: all 0.2s ease;
}
.modern-autocomplete :deep(.v-menu .v-list-item:hover) {
  color: #001763 !important;
  background: #CDD5F3 !important;
}
.modern-autocomplete :deep(.v-menu .v-list-item--active) {
  color: #001763 !important;
  background: #CDD5F3 !important;
}
.modern-autocomplete :deep(.v-overlay__content .v-list-item:hover) {
  color: #001763 !important;
  background: #CDD5F3 !important;
}
.modern-autocomplete :deep(.v-overlay__content .v-list-item--active) {
  color: #001763 !important;
  background: #CDD5F3 !important;
}
.modern-autocomplete :deep(.quickdate-list-item:hover) {
  color: #001763 !important;
  background: #CDD5F3 !important;
}
.modern-autocomplete :deep(.quickdate-list-item.v-list-item--active) {
  color: #001763 !important;
  background: #CDD5F3 !important;
}
.quickdate-list-item:hover {
  color: #001763 !important;
  background: #CDD5F3 !important;
}
.quickdate-list-item.v-list-item--active {
  color: #001763 !important;
  background: #CDD5F3 !important;
}
.modern-autocomplete :deep(.v-autocomplete__menu-icon){
  color: #872612;
  font-size: 32px;
  opacity: 1 !important;
}

</style>
